import { render, staticRenderFns } from "./activitiesVideo.vue?vue&type=template&id=38ab11ca&scoped=true"
import script from "./activitiesVideo.vue?vue&type=script&lang=js"
export * from "./activitiesVideo.vue?vue&type=script&lang=js"
import style0 from "./activitiesVideo.vue?vue&type=style&index=0&id=38ab11ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab11ca",
  null
  
)

export default component.exports